import script from "./Repair04FlatRoof.vue?vue&type=script&setup=true&lang=js"
export * from "./Repair04FlatRoof.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__